import type { DomainMutationOptions } from '@/domain/shared/types';
import { useSmoltReportController_deleteReport } from '@/services/hooks';

import type { UseDeleteReportResult, UseDeleteReportVariables } from './types';

type UseDeleteReportOptions = DomainMutationOptions<{ cageId: number; reportId: number }, void>;

/**
 * Domain hook to delete a smolt report.
 *
 * @param options - Optional mutation options (e.g. onSuccess, onError)
 * @returns Mutation result; mutateAsync resolves when delete succeeds (204)
 */
export const useDeleteReport = (options?: UseDeleteReportOptions): UseDeleteReportResult => {
    const mutation = useSmoltReportController_deleteReport(options);

    const mutateAsync = async (variables: UseDeleteReportVariables): Promise<void> => {
        await mutation.mutateAsync({
            cageId: variables.cageId,
            reportId: variables.reportId,
        });
    };

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: undefined,
    };
};
